
const partiesV2 = [
    {
        label: "ΝΕΑ ΔΗΜΟΚΡΑΤΙΑ",
        color: "#1a6ab2",
        id: 0,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΣΥΡΙΖΑ",
        color: "#fc5559",
        id: 1,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΠΑΣΟΚ - ΚΙΝΑΛ",
        color: "#30c192",
        id: 2,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΚΚΕ",
        color: "#ff0e14",
        id: 3,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΕΛΛΗΝΙΚΗ ΛΥΣΗ",
        color: "#5235d6",
        id: 4,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΠΛΕΥΣΗ ΕΛΕΥΘΕΡΙΑΣ",
        color: "#ff4aca",
        id: 5,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "NIKH",
        color: "#5fb2ff",
        id: 6,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    
    {
        label: "ΜΕΡΑ25",
        color: "#f38268",
        id: 7,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
    {
        label: "ΝΕΑ ΑΡΙΣΤΕΡΑ",
        color: "#a11112",
        id: 8,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΑΛΛΟ",
        color: "#423174",
        id: 9,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "ΔΕΝ ΕΧΩ ΑΠΟΦΑΣΙΣΕΙ",
        color: "#fcbf10",
        id: 10,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
            },
        },
    },
    {
        label: "",
        color: "",
        id: 11,
        data: {
            evaluation: {
                trend: 0,
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
            intention: {
                MAAvg: 0,
                MASum: 0,
                MAIndex: 0,
                percentages: [],
                lastDate: "",
            },
        },
    },
];

export default partiesV2;